module.exports = __webpack_public_path__ + "static/sour-cream-onion-sm-5976c7131241a5f98d2526bf24e959ac.jpg";